import React from "react";
import PropTypes from "prop-types";
import { Segment } from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";

const SimilarcityList = ({
  itemData,
  href,
  prev,
  active,
  header,
  getData,
  customclass,
  isEnabled,
  ...props
}) => {
  let data = itemData.length;
  let page_size = 3;
  let indexdata = (active - 1) * page_size;
  return (
    <div>
      <Segment basic style={{ paddingLeft: 0, paddingRight: 0 }}>
        {itemData
          .slice(indexdata)
          .slice(0, page_size)
          .map((item, index) => (
            <ItemData
              id={item.id}
              key={index}
              href={href + item.cityfullname}
              size={"small"}
              source={
                item.cityimages && item.cityimages.length > 0
                  ? item.cityimages[0].imageurl
                  : process.env.NEXT_PUBLIC_CDN_ID + "static/images/City.jpeg"
              }
              head={item.postalcity_name}
              subhead={
                item.npiscore
                  ? "Overall Score : " +
                    Number(((item.npiscore / 100) * 5).toFixed(2)).toFixed(1)
                  : null
              }
              desc={
                item.valuescore
                  ? "Value : " +
                    Number(((item.valuescore / 100) * 5).toFixed(2)).toFixed(1)
                  : null
              }
              extra={item.reviewOneLiner ? item.reviewOneLiner : null}
              header={header}
              customclass={customclass}
              // onClick={e => getData ? getData(e, item.head):e.preventDefault}
            />
          ))}
        {itemData && itemData.length > 0 && (
          <Paginate
            length={data}
            prev={prev}
            active={active}
            isEnabled={isEnabled}
            {...props}
          />
        )}
      </Segment>
    </div>
  );
};

SimilarcityList.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default SimilarcityList;
